"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  textBox: {
    boxShadow: theme.shadows[25].z8,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3)
  },
  imageRoot: {
    position: "relative"
  },
  button: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "auto 0 0",
    padding: theme.spacing(2, 0, 0)
  },
  avatar: {
    left: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(2)
  }
}));
const SingleTeaser = props => {
  const {
    author,
    teaser
  } = props.data;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  if (!teaser) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const {
    title,
    text,
    media,
    link,
    linkTarget
  } = teaser;
  const {
    filename,
    alt,
    height,
    width
  } = (0, _lodash.first)(media);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 4,
    className: css.imageRoot
  }, /*#__PURE__*/_react.default.createElement(_image.default, {
    filename: filename && REACT_APP_PATH + filename,
    alt: alt,
    height: height,
    width: width
  }), /*#__PURE__*/_react.default.createElement(Author, {
    data: author
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 8,
    className: css.textBox
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "primary",
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: "h2"
  }), text && /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })), /*#__PURE__*/_react.default.createElement(DetectButton, {
    link: link,
    linkTarget: linkTarget
  }))));
};
const DetectButton = props => {
  const {
    link,
    linkTarget
  } = props;
  const css = useStyles();
  const external = link.indexOf("http://") > -1 || link.indexOf("https://") > -1;
  const label = "Weiter";
  if (external) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: css.button
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: link,
      target: linkTarget,
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      color: "secondary",
      variant: "contained"
    }, label)));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: css.button
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      color: "secondary",
      component: _reactRouterDom.Link,
      to: link,
      variant: "contained"
    }, label));
  }
};
const Author = props => {
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  if (!props.data) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const {
    firstname,
    lastname,
    imageSmall
  } = props.data;
  return /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: css.avatar,
    src: REACT_APP_PATH + imageSmall,
    alt: firstname + " " + lastname
  });
};
var _default = exports.default = SingleTeaser;